export { default } from './Label';